import {
  listAuthAccounts,
  selectAuthAccount,
} from "../../../api/auth/accountSelection";

function normalizeAccount(account) {
  return {
    id: account?.id || "",
    name: account?.trade_name || account?.name || account?.legal_name || "Conta sem nome",
    legalName: account?.legal_name || "",
    documentType: account?.document_type || "",
    documentNumber: account?.document_number || "",
    logoUrl: account?.logo_url || "",
    planName: account?.plan_name || "Plano não informado",
    status: account?.status || "",
    roleName: account?.role?.name || "",
    roleSlug: account?.role?.slug || "",
    isAccountOwner: Boolean(account?.is_account_owner),
  };
}

export async function getSelectableAccounts() {
  const response = await listAuthAccounts();
  const data = response?.data || {};

  return {
    accounts: Array.isArray(data.accounts)
      ? data.accounts.map(normalizeAccount)
      : [],
    accountsCount: Number(data.accounts_count || 0),
    accountSelectionRequired: Boolean(data.account_selection_required),
  };
}

export async function chooseAccount(accountId) {
  const response = await selectAuthAccount(accountId);
  return response?.data || {};
}
